import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = [ "recommendationForm", "activationForm", "freeForm" ];

  connect() {
  }

  toggleRecommendation(event) {
    event.preventDefault();
    event.stopPropagation();

    this.recommendationFormTarget.requestSubmit();
  }

  toggleActivation(event) {
    event.preventDefault();
    event.stopPropagation();

    this.activationFormTarget.requestSubmit();
  }

  toggleFree(event) {
    event.preventDefault();
    event.stopPropagation();

    this.freeFormTarget.requestSubmit();
  }
}
